export const url = new URL(
  "https://geektrust.s3-ap-southeast-1.amazonaws.com/adminui-problem/members.json"
);

export const appName = "Admin UI";
export const pageSize = 10;
